import React from 'react';
import { observer } from 'mobx-react';
import { oysterTheme } from '@yaydoo/react-components/lib/theme';

import CloseIcon from '@material-ui/icons/Close';

// import { descargaLink } from '../../../config/variables';
// import { sendEvent } from '../../../utils/utils';
import useStyles from './styles';
import useStore from '@hooks/useStore';
import { IHeaderProps } from '@components/header/types';
import MobileLogoSvg from '@assets/images/logo-mobile.svg';

const HeaderMobile: React.FC<IHeaderProps> = () => {
  const css = useStyles();
  const {
    ui,
    links: {
      coBrandingConfig: { logo },
    },
  } = useStore();

  if (ui.hideMobileHeader) {
    return <div className={css.noHeader}></div>;
  }

  const logoSrc = logo ? logo : MobileLogoSvg;

  const onClose = () => {
    ui.updateField('hideMobileHeader', true);
  };

  const goToApp = () => {
    // sendEvent('Onboarding', 'Click', 'top bar mobile app install');
    // window.open(descargaLink);
  };
  return (
    <div className={css.header}>
      <div className={css.headerContent}>
        <CloseIcon style={{ color: oysterTheme.dolphin }} fontSize="small" onClick={onClose} />
        <div className={css.contentWrapper}>
          <img src={logoSrc} alt="BrandLogo" className={css.headerLogo} />
          <div className={css.headerText}>
            <span>Completa tu registro </span>
            <span>
              en la app <strong>de Oyster</strong>
            </span>
          </div>
          <button className={css.button} type="button" onClick={goToApp}>
            descargar
          </button>
        </div>
      </div>
    </div>
  );
};

export default observer(HeaderMobile);
